<template>
  <div
    :class="[
      'flex flex-wrap items-center', {
        'gap-2': size === 'sm',
        'gap-4': size === 'md',
        'gap-6': size === 'lg',
      },
    ]"
  >
    <template v-if="isMobileOrTablet">
      <button
       
        @click="downloadApp()"
      >
        <img
         
          :alt="downloadButtonImage.alt"
          :class="computedButtonImageClasses"
          :src="downloadButtonImage.src"
          loading="lazy"
          :width="downloadButtonImage.width"
          :height="downloadButtonImage.height"
        >
      </button>
    </template>

    <template v-else>
      <button
        class="block cursor-pointer"
       
        @click="downloadApp({ platform: 'ios' })"
      >
        <img
          :alt="iTunesButtonImage.alt"
          :class="computedButtonImageClasses"
          :src="iTunesButtonImage.src"
          loading="lazy"
          :width="iTunesButtonImage.width"
          :height="iTunesButtonImage.height"
        >
      </button>

      <button
        class="block cursor-pointer"
       
        @click="downloadApp({ platform: 'android' })"
      >
        <img
          :alt="playStoreButtonImage.alt"
          :class="computedButtonImageClasses"
          :src="playStoreButtonImage.src"
          loading="lazy"
          :width="playStoreButtonImage.width"
          :height="playStoreButtonImage.height"
        >
      </button>
    </template>
  </div>
</template>

<script setup lang="ts">
import type { ButtonSize } from '~/components/_tailwind/button/types'

const props = withDefaults(defineProps<{
  size?: ButtonSize
}>(), {
  size: 'sm',
})

const { locale, t } = useI18n()

const { isAndroid, isMobileOrTablet } = useDevice()
const { downloadApp } = useDownloadApp()

const computedButtonImageClasses = computed(() => [
  'w-auto block',
  {
    'h-8': props.size === 'sm',
    'h-12': props.size === 'md',
    'h-14': props.size === 'lg',
  },
])

const imgSize = computed(() => {
  switch (props.size) {
    case 'lg':
      return {
        width: '189',
        height: '56',
      }
    case 'md':
      return {
        width: '162',
        height: '48',
      }
    case 'sm':
    default:
      return {
        width: '108',
        height: '32',
      }
  }
})

const { getStaticImage } = useImage()

const downloadButtonImage = computed(() => {
  return isAndroid ? playStoreButtonImage.value : iTunesButtonImage.value
})

const playStoreButtonImage = computed(() => {
  return {
    src: getStaticImage({
      path: `/app/download/badge-play-store_${locale.value}.svg`,
    }),
    alt: t('appDownloadBanner.googlePlayAction'),
    ...imgSize.value,
  }
})

const iTunesButtonImage = computed(() => {
  return {
    src: getStaticImage({
      path: `/app/download/badge-app-store_${locale.value}.svg`,
    }),
    alt: t('appDownloadBanner.iTunesAction'),
    ...imgSize.value,
  }
})
</script>

<i18n src="~~/i18n/locales/common/app-download-banner.json" lang="json" />
